import React, { memo } from 'react';
import { Modal, Button } from 'tea-component';
import classNames from 'classnames';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import './index.scss';
export interface ConfirmFn {
  click?: (...args: any[]) => void;
  clone: (...args: any[]) => void;
}

export interface ConfirmModalProps<S = string, B = boolean> {
  visible: B;
  title: S;
  desc: S;
  name: S;
  children: React.ReactNode;
  isNeedFooter: boolean;
  className: string;
}

const ConfirmModal = (props: Partial<ConfirmModalProps> & ConfirmFn) => {
  const {
    visible = false,
    click,
    clone,
    title,
    desc,
    children,
    isNeedFooter = true,
    className,
    ...restProps
  } = props;
  const { formatMessage: commonFormat } = useAigcIntl('common');

  return (
    <>
      <Modal
        // className='dbd-subscribepopbox'
        className={classNames('dbd-subscribepopbox', { className })}
        visible={visible}
        onClose={clone}
        {...restProps}
      >
        <Modal.Body>
          {children || (
            <div className="dbd-subscribepopbox-cont">
              <div className="dbd-subscribepopbox-cont-title">{title}</div>
              <span className="dbd-subscribepopbox-cont-text">{desc}</span>
            </div>
          )}
        </Modal.Body>
        {isNeedFooter && (
          <Modal.Footer>
            <Button type="primary" onClick={click}>
              {commonFormat('confirm')}
            </Button>
            <Button type="weak" onClick={clone}>
              {commonFormat('cancel')}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};
export default memo(ConfirmModal);
